// extracted by mini-css-extract-plugin
module.exports = {"page":"pageLayout_page__MBt_W","header":"pageLayout_header__Ccq0r","logo":"pageLayout_logo__2epOG","content":"pageLayout_content__zV_a6"};